<div class="menu-search-container">
  <div class="c-search" [ngClass]="{'mobile': nvdbNavigation.isMobileDevice}">
    <div class="search_options">
      <div class="search_options_container">
        <div class="search_for">{{ lang.GetValue('Searchmenu.SearchFor') }}:</div>
        <div class="search_for_select">
          <trv-select [formControl]="nvdbNavigation.searchMenuState.searchObjectType"
            [source]="nvdbNavigation.searchObjectList" valueKey="id" sortKey="order" [displayMethod]="displayValue"
            [disableClear]="true"></trv-select>
        </div>
      </div>
    </div>

    @if (nvdbNavigation.searchMenuState.searchObjectType.value!.id == 'plats') {
    <trv-select class="mb-3" [multi]='true' [formControl]='nvdbNavigation.searchMenuState.platsSearch'
      [source]='nvdbNavigation.availablePlatsSearchFilter' placeholder="{{ lang.GetValue('Searchmenu.Filter') }}"
      valueKey='value' [displayMethod]='displayValue'></trv-select>
    }

    <div class="input-group">
      <input id="searchInput" type="search" class="form-control"
        [placeholder]="nvdbNavigation.searchMenuState.searchObjectType.value!.placeholder ? nvdbNavigation.searchMenuState.searchObjectType.value!.placeholder : nvdbNavigation.searchMenuState.searchObjectType.value!.displayName"
        aria-label="Sök" aria-describedby="button-addon23"
        [formControl]="nvdbNavigation.searchMenuState.searchString" />
      <button class="btn btn-primary" type="button" id="button-addon23">
        <app-svg-icon [svgIcon]="searchIcon"></app-svg-icon>
        <span class="visually-hidden">{{ lang.GetValue('Searchmenu.Search') }}</span>
      </button>
    </div>

    @if (nvdbNavigation.searchMenuState.searchState == SearchState.ToShortString) {
    <div @trvCollapseVoidAnimation>
      <p class="alert alert-warning c-search__nohits">{{ lang.GetValue('Searchmenu.SearchErr') }}</p>
    </div>
    }

    @if (nvdbNavigation.searchMenuState.searchState == SearchState.Loading) {
    <div [trv-loading]="true" @trvCollapseVoidAnimation style="margin-top: 1rem; background-color: #ececec"></div>
    }
    @if (nvdbNavigation.searchMenuState.searchState == SearchState.Success) {
    <div [ngClass]="{'mobile-search-container': nvdbNavigation.isMobileDevice}" @trvCollapseVoidAnimation>


      <!--<div style="margin-top: 0.3rem">{{ nvdbNavigation.searchMenuState.currentSearchItems.length }} resultat</div>-->

      <div style="margin-top: 0.3rem">
        {{ nvdbNavigation.searchMenuState.currentSearchItems.length }}
        {{
        nvdbNavigation.searchMenuState.currentSearchItems.length === 1
        ? lang.GetValue('Searchmenu.Result')
        : lang.GetValue('Searchmenu.Results')
        }}
      </div>


      <div class="search-container-outer" [ngClass]="{'mobile': nvdbNavigation.isMobileDevice}">
        <div class="search-item-container">
          @for (searchItem of nvdbNavigation.searchMenuState.currentSearchItems; track searchItem; let indx = $index) {
          <app-search-item [searchItem]="searchItem" [first]="indx == 0"></app-search-item>
          }
        </div>
      </div>
    </div>
    }

    @if (nvdbNavigation.searchMenuState.searchState == SearchState.NoResults) {
    <div @trvCollapseVoidAnimation>
      <p class="alert alert-warning c-search__nohits">
        {{ lang.GetValue('Searchmenu.NoResults') }}
        <span class="nohit">"{{ nvdbNavigation.searchMenuState.searchString.value }}"</span>
      </p>
    </div>
    }
  </div>
</div>